import { EnumSchema } from '../metadata-schema';

export const UitstroomtypeVSO: EnumSchema = {
	"type": "string",
	"title": "UitstroomtypeVSO",
	"enum": [
		"Einduitstroom",
		"Tussentijdse uitstroom"
	]
};
